let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5rwjP")).then(() => parcelRequire('52jDP'));